import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';

const launchDate = new Date('2026-09-01T09:00:00+02:00');

function getCountdown() {
  const now = new Date();
  const diff = launchDate.getTime() - now.getTime();

  if (diff <= 0) {
    return 'Fulfillment is now live';
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  return `${days} days until fulfillment starts`;
}

function Home() {
  return (
    <main className='landing-page'>
      <section className='launch-hero'>
        <picture className='hero-picture'>
          <source media='(max-width: 900px)' srcSet='/images/mukwei-cinematic-hero-960.webp' />
          <img
            className='hero-image'
            src='/images/mukwei-cinematic-hero-1600.webp'
            alt=''
            fetchPriority='high'
          />
        </picture>
        <div className='hero-effects' aria-hidden='true'>
          <span className='smoke-wisp smoke-one' />
          <span className='smoke-wisp smoke-two' />
          <span className='smoke-wisp smoke-three' />
          <span className='glass-shimmer' />
        </div>
        <div className='hero-overlay' />
        <div className='hero-content'>
          <p className='hero-eyebrow'><span /> Limited inaugural release</p>
          <h1>Bold by nature.<br /><em>Distinctly Mukwei.</em></h1>
          <p className='hero-subtitle'>
            A premium South African gin created for unhurried moments, layered conversation and a
            serve that lingers.
          </p>
          <div className='launch-meta'>
            <span>01</span>
            <p><strong>First release</strong>Deliveries begin 1 September 2026</p>
            <span>02</span>
            <p><strong>Limited allocation</strong>R320 per 750ml bottle</p>
          </div>
          <div className='hero-actions'>
            <Link to='/checkout' className='cta-button primary'>
              Reserve your bottle <span aria-hidden='true'>↗</span>
            </Link>
            <Link to='/track' className='text-link'>
              Track an order <span aria-hidden='true'>→</span>
            </Link>
          </div>
          <p className='hero-countdown'>{getCountdown()}</p>
        </div>
        <div className='scroll-cue'><span /> Discover Mukwei</div>
      </section>

      <section className='story-section'>
        <div className='story-image-wrap'>
          <picture>
            <source media='(max-width: 700px)' srcSet='/images/mukwei-product-720.webp' />
            <img
              src='/images/mukwei-product-1200.webp'
              alt='Mukwei Gin bottle served with a fresh botanical gin and tonic'
              loading='lazy'
              decoding='async'
            />
          </picture>
          <span className='image-edition'>01 / Inaugural edition</span>
        </div>
        <article className='story-copy'>
          <p className='section-kicker'>The first pour</p>
          <h2>Made for the<br /><em>moment.</em></h2>
          <p>
            Mukwei is an expression of modern South African celebration: confident, considered and
            grounded in the pleasure of sharing a beautifully made drink.
          </p>
          <div className='tasting-notes'>
            <div><span>01</span><strong>Bright</strong><small>Citrus lift</small></div>
            <div><span>02</span><strong>Botanical</strong><small>Fresh aromatics</small></div>
            <div><span>03</span><strong>Smooth</strong><small>Clean finish</small></div>
          </div>
          <Link to='/checkout' className='text-link gold'>Secure the first release <span>→</span></Link>
        </article>
      </section>

      <section className='release-strip'>
        <video
          className='release-video'
          src='/videos/MukweiGin-web.mp4'
          poster='/images/mukwei-cinematic-hero-1600.webp'
          autoPlay
          loop
          muted
          playsInline
          preload='metadata'
          aria-hidden='true'
        />
        <div className='release-video-shade' />
        <div className='release-content'>
          <p>One spirit · One moment · One limited release</p>
          <h2>Have a sip and feel the moment.</h2>
          <Link to='/checkout' className='cta-button light'>Pre-order now</Link>
        </div>
      </section>

      <aside className='age-notice'>
        <span className='age-badge'>18+</span>
        <p><strong>Enjoy responsibly.</strong> Mukwei Gin is not for sale to persons under the age of 18.</p>
      </aside>
    </main>
  );
}

export default Home;
